export const languageCountryCode: Record<string, string> = {
  'English': 'GB',
  'Spanish': 'ES',
  'German': 'DE',
  'French': 'FR',
  'Italian': 'IT',
  'Norwegian': 'NO',
  'Dutch': 'NL',
  'Danish': 'DK',
  'Swedish': 'SE',
  'Portuguese': 'PT',
  'Polish': 'PL',
};
